import { createSvgIcon } from '@mui/material/utils'

export default createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M1.4 7.2a3.4 3.4 0 0 1 3.4-3.4h14.4a3.4 3.4 0 0 1 3.4 3.4v9.6a3.4 3.4 0 0 1-3.4 3.4H4.8a3.4 3.4 0 0 1-3.4-3.4V7.2Zm3.401-1.4 7.085 4.905a.2.2 0 0 0 .228 0L19.199 5.8H4.8ZM20.6 7.2a.998.998 0 0 1-.23.222l-7.118 4.927a2.2 2.2 0 0 1-2.504 0L3.63 7.422A1 1 0 0 1 3.4 7.2v9.6a1.4 1.4 0 0 0 1.4 1.4h14.4a1.4 1.4 0 0 0 1.4-1.4V7.2Z"
  />,
  'Email'
)
